import React from 'react';

interface DemoProps {
  theme: 'light' | 'dark';
}

const Demo: React.FC<DemoProps> = ({ theme }) => {
  const accentColor = "#00CCEB";

  const videoData = [
    {
      id: "-9dTkt2tOzU",
      title: "Main Demo",
      description: "A comprehensive overview of SpotEQ31's core features and how it integrates with your favorite music players on Android."
    },
    {
      id: "QjXJTtXm45E",
      title: "Built-in Media Player",
      description: "Learn how to use the integrated media player to listen to your local files and podcasts with full EQ control."
    },
    {
      id: "Tu-LFs2Nuno",
      title: "Android 14 performance",
      description: "How to fix the connection issues on some Android 14 devices by following a specific order of enabling the app and starting music."
    },
    {
      id: "w3FiV-_xglI",
      title: "How to EQ any Android sound, music or video app with SpotEQ31",
      description: "SpotEQ31 on Android should work with any sound on your device, but sometimes a third-party app might stop eq working."
    },
    {
      id: "iIsRkPeeQgs",
      title: "How to improve performance of SpotEQ31 on a OnePlus Nord CE 5 with Android 13",
      description: "It's important to allow all permissions and notification types and to remove any battery optimisations for the app to function properly in the background."
    }
  ];

  return (
    <div style={{ padding: "40px 20px", maxWidth: "900px", margin: "0 auto", lineHeight: "1.6" }}>
      <section style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>App <span style={{ color: accentColor }}>Demo & Tutorials</span></h1>
        <p style={{ fontSize: '1.2rem', maxWidth: '700px', margin: '0 auto' }}>
          Watch our videos to see SpotEQ31 in action and learn how to master your audio experience on Android.
        </p>
      </section>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '60px' }}>
        {videoData.map((video, index) => (
          <div key={index}>
            <h2 style={{ marginBottom: '10px', color: theme === 'dark' ? '#fff' : '#000' }}>{video.title}</h2>
            <p style={{ marginBottom: '20px', fontSize: '1.05rem' }}>{video.description}</p>
            <div style={{ 
              position: 'relative', 
              paddingBottom: '56.25%', /* 16:9 Aspect Ratio */
              height: 0, 
              overflow: 'hidden',
              borderRadius: '20px',
              background: theme === 'dark' ? '#1a1a1a' : '#f0f4f8',
              boxShadow: theme === 'dark' ? '0 10px 30px rgba(0, 204, 235, 0.1)' : '0 10px 20px rgba(0,0,0,0.1)',
            }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 0
                }}
                src={`https://www.youtube.com/embed/${video.id}`}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        ))}
      </div>

      <footer style={{ fontSize: '0.8rem', opacity: 0.7, textAlign: 'center', borderTop: '1px solid #444', paddingTop: '20px', marginTop: '60px' }}>
        <p>Subscribe to our <a href="https://www.youtube.com/@leanderoiddevelopment1718/videos" target="_blank" rel="noopener noreferrer" style={{ color: accentColor, textDecoration: 'none', fontWeight: 'bold' }}>YouTube channel</a> for more tips and tutorials.</p>
      </footer>

      <style>{`
        @media (max-width: 600px) {
          h1 {
            font-size: 2.5rem !important;
          }
          h2 {
            font-size: 1.5rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Demo;
